module.exports = __webpack_public_path__ + "img/image7.552c9853.png";